(() => {
  'use strict';

  const finishes = {
    Oak: 'oak',
    'Light Oak': 'light-oak',
    'Grey Oak': 'grey-oak',
    'Smoked Oak': 'smoked-oak',
    Grey: 'grey',
    Sand: 'sand',
    Walnut: 'walnut',
    Black: 'black'
  };
  const rooms = [
    ['living', 'Living room'],
    ['dining', 'Dining room'],
    ['bedroom', 'Bedroom']
  ];
  const activeFinishes = new WeakMap();
  const base = 'assets/homewoods-finish-rooms-v1/';
  const asset = path => window.HomewoodsAssetUrls[path] || path;
  const sizes = '(max-width: 749px) calc(100vw - 40px), (max-width: 1100px) 50vw, 620px';

  function imagesFor(finish) {
    const slug = finishes[finish];
    if (!slug) return [];
    const images = rooms.map(([room, label]) => ({
      room, label,
      src: asset(`${base}${slug}-${room}.webp`),
      srcset: [480, 768, 1086].map(width => `${asset(`${base}${slug}-${room}-${width}.webp`)} ${width}w`).join(', '),
      thumb: asset(`${base}${slug}-${room}-240.webp`),
      alt: `${finish} slatted wall panels in a ${label.toLowerCase()}`,
      caption: `${finish} · ${label}`
    }));
    const macro = asset(`assets/homewoods-finish-macro-v1/homewoods-macro-${slug}-v1.webp`);
    images.push({
      label: 'Material detail', src: macro, srcset: '', thumb: macro,
      alt: `${finish} finish, close-up of timber slats and black felt backing`,
      caption: `${finish} · Material detail`
    });
    return images;
  }

  function sync(root, finish, showImage) {
    const gallery = root.querySelector('[data-hw-gallery]');
    const images = imagesFor(finish);
    if (!gallery || !images.length) return false;
    if (activeFinishes.get(root) === finish) return true;
    activeFinishes.set(root, finish);
    const buttons = Array.from(gallery.querySelectorAll('[data-gallery-select]'));
    const selected = buttons.find(button => button.getAttribute('aria-current') === 'true') || buttons[0];

    buttons.forEach((button, index) => {
      const item = images[index];
      if (!item) return;
      button.dataset.src = item.src;
      button.dataset.srcset = item.srcset;
      button.dataset.alt = item.alt;
      button.dataset.caption = item.caption;
      button.dataset.galleryIndex = String(index + 1);
      button.setAttribute('aria-label', `${index + 1} of ${images.length}: ${finish}, ${item.label.toLowerCase()}`);
      const thumbnail = button.querySelector('img');
      thumbnail.src = item.thumb;
      thumbnail.removeAttribute('srcset');
      button.querySelector('span').textContent = item.label;
    });
    gallery.dataset.finish = finish;
    gallery.querySelector('[data-main-image]').sizes = sizes;
    showImage(selected.dataset.src, selected.dataset.alt, selected);

    const opening = document.querySelector('#homewoods-opening');
    opening?.querySelectorAll('[data-opening-slide]').forEach((slide, index) => {
      const item = images[index];
      if (!item?.room) return;
      const image = slide.querySelector('img');
      image.removeAttribute('srcset');
      image.src = item.src;
      image.alt = item.alt;
      slide.dataset.openingRoom = `${finish} · ${item.label}`;
      slide.setAttribute('aria-label', `${index + 1} of 3: ${finish}, ${item.label}`);
      const dot = opening.querySelector(`[data-opening-go="${index}"]`);
      dot?.setAttribute('aria-label', `Show ${finish} in the ${item.label.toLowerCase()}`);
    });
    if (opening) opening.dataset.finish = finish;
    document.dispatchEvent(new CustomEvent('homewoods:finish-gallery-change', { detail: { finish } }));
    return true;
  }

  window.HomewoodsFinishGallery = { sync, imagesFor };
})();
